export const environment = {
  production: true,
  homePath: '/text-entry',
  configPath: 'assets/config.json',
  server: 'http://numinus:2265',
  emtelliproServer: 'http://numinus:2265',
  iamServer: 'http://numinus:12265',
  commitId: 'dadc23b8',
  timeStamp: '2023.03.17'
};
